// @ts-check

/** @file Adds safe automation eligibility to the local project catalog. */

import Migration from "velocious/build/src/database/migration/index.js"

/** Adds the public project automation assignment capability used by online commands. */
export default class AddProjectAutomationAssignable extends Migration {
  /** Adds the catalog presentation column. */
  async up() {
    await this.addColumn("projects", "automation_assignable", "boolean", {default: () => "0", null: false})
  }

  /** Removes the catalog presentation column. */
  async down() {
    await this.removeColumn("projects", "automation_assignable")
  }
}
